import { Page } from '../../components/layout';
import {
  INVESTOR_QUESTIONS,
} from '../../constants/faq';
import FAQSection from '../HomeownersLandingPage/Components/FAQSection';
import styles from './index.module.scss';

export default (props) => {
  const { selectedQuestion } = props;
  return (
    <Page
      className={styles['faq-page']}
      pageInner={styles['page-inner']}
      pageInnerContent={styles['page-inner-content']}
    >
      <div className={styles['top-section']}>
        <div className={styles['section-inner']}>
          {selectedQuestion ? (
            <>
              <h1>{selectedQuestion?.title || 'FAQ'}</h1>
              <div className={styles['desc-wrapper']}>
                <div className={styles['answer-title']}>ANSWER</div>
                <br />
                <p
                  className={styles.desc}
                  dangerouslySetInnerHTML={{ __html: selectedQuestion.desc }}
                />
              </div>
            </>
          ) : (
            <h1>Frequently Asked Questions</h1>
          )}
        </div>
      </div>
      <div className={styles['section-inner']}>
        {/* <FAQSection
          sectionInnerClass={styles['faq-section-inner']}
          titleClass={styles['section-title']}
          variantData={{ faq: SELLER_QUESTIONS }}
          title="Sellers"
          backgroundColor="white"
        /> */}
        <FAQSection
          sectionInnerClass={styles['faq-section-inner']}
          titleClass={styles['section-title']}
          variantData={{ faq: INVESTOR_QUESTIONS }}
          title="Partners"
          backgroundColor="white"
        />
      </div>
    </Page>
  );
};
